import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next"; // 👈 importación

export default function Faqs() {
	const [openIndex, setOpenIndex] = useState(null);
	const { t } = useTranslation();

	const faqs = t("faqs.items", { returnObjects: true }); // 👈 obtenemos array traducido

	return (
		<section className="pt-32 pb-20 bg-gray-50">
			<div className="max-w-3xl mx-auto px-6">
				<motion.h2
					className="text-4xl md:text-5xl font-extrabold text-center text-gray-900 mb-12"
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true, amount: 0.3 }}
				>
					{t("faqs.title")}
				</motion.h2>

				<div className="space-y-4">
					{faqs.map((faq, i) => (
						<div
							key={i}
							className="bg-white rounded-xl shadow-sm hover:shadow-md transition"
						>
							<button
								onClick={() => setOpenIndex(openIndex === i ? null : i)}
								className="flex w-full items-center justify-between px-6 py-4 text-left"
							>
								<span className="text-gray-900 font-medium">
									{faq.question}
								</span>
								<ChevronDown
									className={`w-5 h-5 text-gray-500 transition-transform ${
										openIndex === i ? "rotate-180" : ""
									}`}
								/>
							</button>

							<AnimatePresence>
								{openIndex === i && (
									<motion.div
										initial={{ height: 0, opacity: 0 }}
										animate={{ height: "auto", opacity: 1 }}
										exit={{ height: 0, opacity: 0 }}
										transition={{ duration: 0.3, ease: "easeInOut" }}
									>
										<div className="px-6 pb-4 text-gray-600 text-sm whitespace-pre-line">
											{faq.answer}
										</div>
									</motion.div>
								)}
							</AnimatePresence>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
